import { render, staticRenderFns } from "./paynow-order.vue?vue&type=template&id=13c1d790&scoped=true&"
import script from "./paynow-order.vue?vue&type=script&lang=js&"
export * from "./paynow-order.vue?vue&type=script&lang=js&"
import style0 from "./paynow-order.vue?vue&type=style&index=0&id=13c1d790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1d790",
  null
  
)

export default component.exports